let failedRequests = 0;

export default {
    backIfFirst: function (current) {
        // Code stolen from one of eti's other projects
        // this.$f7router.view
        if (
            f7.views['main'].router.history[f7.views['main'].router.history.length - 1] ===
            f7.views['main'].router.url
        ) {
            if (
                f7.views['main'].router.history.length > 1 &&
                f7.views['main'].router.history[f7.views['main'].router.history.length - 2] !==
                    f7.views['main'].router.url
            ) {
                return current.$f7router.view.router.back(
                    f7.views['main'].router.history[f7.views['main'].router.history.length - 2]
                );
            }
            f7.views['main'].router.navigate('/home', {
                clearPreviousHistory: true,
                transition: 'f7-fade'
            });
        } else {
            current.$f7router.view.router.back();
        }
    },
    extend: function (obj, src) {
        Object.keys(src).forEach(function (key) {
            obj[key] = src[key];
        });
        return obj;
    },
    getCookie: function (cname) {
        var name = cname + '=';
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    },
    renderUnitType: type => {
        if (type === 'lesson') type = 'learn';
        else if (type === 'story') type = 'listen';
        else if (type === 'game') type = 'play';
        else if (type === 'question') type = 'ask';
        else if (type === 'quiz') type = 'learn';
        else if (type === 'post') type = 'journal';
        return type;
    },
    failedRequest: (view, error, fullReload) => {
        console.error(error);
        if (error.status === 401) {
            if (error.body.message === 'Expired authentication token.') {
                Vue.http.headers.common.jwt = '';
                localStore.removeItem('jwt');
                f7.views[view || 'main'].router.refreshPage();
            } else {
                // Do not do this on auth errors for now.
                return;
            }
        }
        failedRequests++;
        if (failedRequests > 1) return;
        let text =
            'Oops! There was a problem connecting to the server. Luckily connection is kind of our thing.';
        if (window.store && window.store.user && window.store.user.isAdmin) {
            text += ` ${error.status}: ${error.url}`;
        }
        var toastWithCallback = f7.toast.create({
            text,
            closeButton: true,
            closeTimeout: 10000,
            closeButtonText: 'Try again',
            closeButtonColor: 'red',
            on: {
                close: () => {
                    if (fullReload || failedRequests > 2) {
                        if (pgap) {
                            window.location.reload();
                        } else {
                            window.location.href = '/';
                        }
                    } else {
                        f7.views[view || 'main'].router.refreshPage();
                        failedRequests = 0;
                    }
                }
            }
        });
        toastWithCallback.open();
    },
    isMobile: function () {
        var isMobile = false;
        if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
                navigator.userAgent
            ) ||
            // eslint-disable-next-line no-useless-escape
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                navigator.userAgent.substr(0, 4)
            )
        )
            isMobile = true;
        return isMobile;
    },
    checkTraitSets: (myTraits, traitSets) => {
        // somewhere undefined is injected
        if (R.isNil(traitSets)) return true;

        let result = [];
        // console.log('the length of the traitSets', traitSets.length);
        // console.log('traitsets', JSON.stringify(traitSets, null, ' '));
        for (let i = 0; i < traitSets.length; i++) {
            let set = traitSets[i];
            let operator = set.traitType || 'OR';

            // console.log('the operator is', operator);
            // console.log('the set is', set);

            const nonTraits = set.nontraits ? set.nontraits.flat() : [];
            // console.log('my non traits', nonTraits);
            const traits = set.traits || [];
            // console.log('my traits', traits);

            // Excluded implies that we do not want to show it to the user
            const isExcluded = set.traitRule === 'Exclude';
            const isIncluded = !isExcluded;
            const existInNonTraits = nonTraits.length
                ? myTraits.some(x => nonTraits.includes(x))
                : false;
            const existInTraits = myTraits.some(x => traits.includes(x));

            const showToUser = () => {
                if (operator === 'AND' && isIncluded) {
                    // it it exists in non traits we don't want to show it
                    //
                    // console.log('AND and is included - existInNonTraits', existInNonTraits);
                    // console.log('show', !existInNonTraits);
                    return !existInNonTraits;
                } else if (operator === 'OR' && isIncluded) {
                    // console.log('OR and is included - existInTraits', existInTraits);
                    // console.log('show', existInTraits);
                    return existInTraits;
                } else if (operator === 'AND' && isExcluded) {
                    // console.log('AND and is excluded - existInNonTraits', existInNonTraits);
                    // console.log('show', existInNonTraits);
                    return existInNonTraits;
                } else if (operator === 'OR' && isExcluded) {
                    // console.log('OR and isExluded - existInTraits', existInTraits);
                    // console.log('show', !existInTraits);
                    return !existInTraits;
                }
            };

            //console.log(`the response of traitSet #${i}`, showToUser());

            result.push(showToUser());
        }

        // console.log('the result of all the traitSets', result);

        // if the first traitSet is false and the second is true then we don't show it
        // they both have to be true

        const equalsTrue = R.equals(true);
        return R.all(equalsTrue)(result);
    },
    checkTraits: function (myTraits, item) {
        // if (!item || !item.id) return false;

        // console.log('original traitSets', JSON.stringify(item, null, ' '));
        // console.log('my Traits', JSON.stringify(myTraits, null, ' '));

        if (R.isEmpty(item.data.traitSets)) return true;

        // there is two different data structure
        // one with versions and one without it
        const { versions, data } = item;
        if (versions) {
            const allVersions = versions.map(version => {
                // we check that it's published otherwise
                // it will take into account unpublished version that may
                // return checkTraitSets to be true
                return version.published && this.checkTraitSets(myTraits, version.data.traitSets);
            });

            // console.log('all versions are', allVersions);
            // if any of the versions return true then we can show it to the screen
            const equalsTrue = R.equals(true);

            // console.log('versions render return', R.any(equalsTrue)(allVersions));
            return R.any(equalsTrue)(allVersions);
        }

        return this.checkTraitSets(myTraits, data.traitSets);
    },
    shareModule: (text, desc, url, type, userId) => {
        let fullUrl = `https://getcoral.app/web${url}`;
        if (pgap) {
            if (window.Branch) {
                window.Branch.createBranchUniversalObject({
                    canonicalIdentifier: url,
                    title: text,
                    contentDescription: desc,
                    contentImageUrl: 'https://getcoral.app/home/images/og.jpg',
                    contentMetadata: {
                        userId
                        // type,
                        // app_version: window.version
                    }
                })
                    .then(BranchLink => {
                        const analytics = {
                            campaign: 'User initiated unit sharing',
                            channel: 'REFERRAL',
                            feature: 'Unit share button'
                            // stage: "new user",
                            // tags: ["one", "two", "three"]
                        };

                        // optional fields
                        const properties = {
                            $desktop_url: fullUrl
                            // custom_string: 'data',
                            // custom_integer: Date.now(),
                            // custom_boolean: true
                        };

                        // share sheet
                        BranchLink.showShareSheet(analytics, properties, text);
                    })
                    .catch(function (err) {
                        console.log('Branch Error: ' + JSON.stringify(err));
                    });
            } else {
                const message = {
                    text,
                    url: fullUrl
                };
                window.socialmessage.send(message);
            }
        } else {
            const webPopup = (text, fullUrl) => {
                const buttons = [
                    {
                        text: 'Email',
                        onClick: () => {
                            window.open(
                                `mailto:?subject=I want to share a link with you&body=%0d%0a${text}%0d%0a%0d%0a${fullUrl}`
                            );
                        }
                    },
                    {
                        text: 'Twitter',
                        onClick: () => {
                            window.open(
                                `https://twitter.com/intent/tweet/?text=${text}&url=${fullUrl}`
                            );
                        }
                    },
                    {
                        text: 'Facebook',
                        onClick: () => {
                            window.open(`https://facebook.com/sharer/sharer.php?u=${fullUrl}`);
                        }
                    }
                ];
                f7.actions
                    .create({
                        title: 'Share',
                        text,
                        buttons
                    })
                    .open();
            };

            if (!window.branch) {
                return webPopup(text, fullUrl);
            }
            window.branch.link(
                {
                    campaign: 'User initiated unit sharing',
                    channel: 'REFERRAL',
                    feature: 'unit',
                    // stage: 'new user',
                    data: {
                        userId,
                        // type,
                        // app_version: window.version,
                        $desktop_url: fullUrl,
                        //     $ios_url: 'http://myappwebsite.com/ios',
                        //     $ipad_url: 'http://myappwebsite.com/ipad',
                        //     $android_url: 'http://myappwebsite.com/android',
                        //     $og_app_id: '12345',
                        $og_title: text,
                        $og_description: desc,
                        $og_image_url: 'https://getcoral.app/home/images/og.jpg'
                    }
                },
                (err, link) => {
                    if (err) console.log(err);
                    return webPopup(text, link || fullUrl);
                }
            );
        }
    },
    actionLog: (logParams) => {
        // Options: {
        //   location: string; component name
        //   method: string; method name where logging
        //   action: string; action name which is performing
        //   info: string; additional info
        //   dataValue: any; any data to be displayed
        // }

        const location = logParams.location;
        const action = logParams.action;
        const method = logParams.method;
        const info = logParams.info;
        const dataValue = logParams.dataValue;

        switch (action) {
        case 'load':
            console.log(`[${location}][${method}] ${action}ing ${info}s...`);
            break;

        case 'use':
            console.log(`[${location}][${method}] ${action} ${dataValue} for ${info}s`);
            break;

        case 'done':
            console.log(`[${location}][${method}] ${info}s loaded: ${dataValue}`);
            break;

        default:
            console.log(`[${location}][${method}] ${action || ''} ${info || ''} ${dataValue || ''}`);
        }
    }
};
